import { render, staticRenderFns } from "./DetailAppointments.vue?vue&type=template&id=021cbe60"
import script from "./DetailAppointments.vue?vue&type=script&lang=js"
export * from "./DetailAppointments.vue?vue&type=script&lang=js"
import style0 from "./DetailAppointments.vue?vue&type=style&index=0&id=021cbe60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports